/* eslint-disable no-console */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { AppRoutePath } from '../../common/constants';
import LanguageTexts from '../../common/language';
import { RootState } from '../../common/types';
import AppLoader from '../../components/AppLoader';
import AppTable from '../../components/AppTable';
import { loadTeams } from './teams.slice';

const TeamListPage = (): JSX.Element => {
  const { teams: teamsTxt } = LanguageTexts;
  const dispatch = useDispatch();
  const { teams, loading } = useSelector((state: RootState) => state.teams);
  const { user: currentUser } = useSelector((state: RootState) => state.login);
  const [loadRequested, setLoadRequested] = useState(false);

  const columns = React.useMemo(
    () => [
      {
        Header: teamsTxt.team,
        accessor: 'name',
        Cell: ({
          row: {
            original: { _id, name },
          },
        }: // eslint-disable-next-line @typescript-eslint/no-explicit-any
        any) => {
          return (
            <Link to={`${AppRoutePath.TeamsUpdate.replace(':teamId', _id)}`}>
              {name}
            </Link>
          );
        },
      },
      {
        Header: teamsTxt.sportType,
        accessor: 'sporttype.name',
      },
    ],
    [teamsTxt],
  );

  const data = React.useMemo(
    () =>
      teams?.map(({ _id: teamId, ...restTeam }) => {
        return {
          _id: teamId,
          ...restTeam,
        };
      }),
    [teams],
  );

  useEffect(() => {
    if (!loadRequested) {
      dispatch(loadTeams(''));
      setLoadRequested(true);
    }
  }, [loadRequested, currentUser, dispatch]);

  if (loading || !loadRequested) {
    return <AppLoader />;
  }

  return (
    <section className="list-table">
      <h1 className="primary-heading mb-4">
        {teamsTxt.teams}
        <Link
          className="btn btn-success"
          style={{ float: 'right', fontSize: 18 }}
          to={AppRoutePath.TeamsCreate}
        >
          {teamsTxt.newTeam}
        </Link>
      </h1>
      <AppTable columns={columns} data={data || []} />
    </section>
  );
};

export default TeamListPage;
